import React from 'react';

export default function HTML_Audio_Video() {
  return (
    <div className="HTML_Audio_Video">
      <h1>HTML Audio/Video</h1>
      <p>This is the placeholder component for <strong>HTML Audio/Video</strong>.</p>
      <p>Link: /html/reference/audio-video</p>
    </div>
  );
}
